






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  companiesCollection,
  safetyCollection,
  wellControlCollection,
} from '@/firebaseConfig.ts';
import { auth } from '@/firebaseConfig.ts';
import { User } from '../../types';

@Component
export default class Login extends Vue {
  incident: Object | undefined = {};
  posts: Array<Object> = [];

  hasPhoto(post: Object): boolean {
    return (
      (post && post.hasOwnProperty('photos') && post['photos'].length > 0) ||
      false
    );
  }

  getLocation(post: Object): string {
    const state: string = post['state'];
    const country: string = post['country'];
    if (state) {
      if (country)
        return state + ", " + country;
      else
        return state;
    } else if (country) return country;
    return '';
  }

  getRatingGrade(rating): string {
    if (rating >= 90) return 'A';
    if (rating >= 80) return 'B';
    if (rating >= 70) return 'C';
    if (rating >= 60) return 'D';
    return 'F';
  }

  getRatingColor(rating) {
    const grade = this.getRatingGrade(rating);
    switch (grade) {
      case 'A':
        return '#4CAF50';
      case 'B':
        return '#2196F3';
      case 'C':
        return '#FBC02D';
      case 'D':
        return '#F57C00';
      default:
        return '#D32F2F';
    }
  }

  async mounted() {
    const docRef = await wellControlCollection
      .orderBy('timestamp', 'desc')
      .onSnapshot(snapshot => {
        if (!snapshot.empty) {
          snapshot.docs.forEach(doc => {
            const data = doc.data();
            data['id'] = doc.id;
            this.posts.push(data);
          });
          console.log(this.posts);
        } else {
          console.log('Snapshot does not exist');
        }
      });
  }
}
